import styled from 'styled-components';
import { getScreenMaxWidth } from '../../utils/bundle.esm3.js';

const SliderStyled = styled.div`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  overflow: hidden;
  max-width: min(
    ${(props) => (props.slideWidth + props.gap) * props.slidesCount - props.gap}px,
    100%,
    ${getScreenMaxWidth()}
  );

  .slick-list {
    overflow: initial;
    width: ${(props) => props.slideWidth + props.gap}px;
  }

  .slick-slide {
    &:not(:last-child) {
      .Slider__slide {
        margin-right: ${(props) => props.gap}px;
      }
    }
  }

  .slick-prev,
  .slick-next {
    z-index: 2;
  }

  .Slider {
    &__slide {
      overflow: hidden;
      max-width: ${(props) => props.slideWidth}px;
      height: ${(props) => props.height}px;
    }
  }
`;

export { SliderStyled as default };
//# sourceMappingURL=bundle.esm3.js.map
